import image1 from "@/assets/images/clients/client-logo-playstation-mono.png";
import image2 from "@/assets/images/clients/client-logo-meshh-mono.png";
import image3 from "@/assets/images/clients/client-logo-ivory-mono.png";
import image4 from "@/assets/images/clients/client-logo-lsh-mono.png";
import image5 from "@/assets/images/clients/client-logo-cpac-mono.png";
import image6 from "@/assets/images/clients/client-logo-gtcap-mono.png";

/*
  TWEET SECTION
  Tweet Overview section
  https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/overview
  Tweet Plugin For Vue
  https://www.npmjs.com/package/vue-tweet-embed
*/
export default {
  /* 
  All section has 
    title -> section title
    col -> col classname to passed in div
    icon -> icon name
    detail -> details of the section
  */
  //  About me intro section
  intro: {
    title: "GREETINGS PROGRAM!!!",
    col: "col-md-7",
    icon: "icon-guest",
    details: `<p>Welcome to my website, a place of shameless self-promotion brought to you by me, Nik Buckman (though "Buck" will do just fine.  My forename gives me neck ache).</p>
              <p>I'm a web and app&nbsp;developer from London with a passion for mobile technology, music, cinema, snowboarding, martial arts, nerdy stuff, vegan baking, adventures... (the list keeps going so lets move on shall we?)</p>
              <p>My love for mobile probably stems from a genetically inherited interest in radio communications (my Grandad was a radio engineer). Now my interests are in mobile apps and how their content platforms allow different and complex types of datasets to be exchanged and displayed elegantly, so that it can be useful to regular humans and not just computer nerds (plus let's be honest, the Google maps API is as data porn as it gets!).</p>
              <p>I'm generally quite active.&nbsp; I regularly train in a few different martial arts, enjoy going to live gigs, practically live at my local cinema.&nbsp; I used to be a scout leader so camping and hiking are <em>(literally)</em> second nature, and I've snowboarded in Scotland, France and (believe it or not) Slovakia, where I was once considered to be somewhat of a cultural novelty. <i class="far fa-smile-wink"></i></p>
            `
  },

  // Tweet section
  // tweet: {
  //   title: "LATEST TWEETS",
  //   col: "col-md-4",
  //   icon: "icon-twitter",
  //   id: process.env.VUE_APP_TWITTER_ID
  // },

  // More XP
  skills:
    //   Skills by group with main title and details
    {
      title: "MORE XP",
      icon: "fas fa-gamepad",
      col: "col-md-5",
      details: [
        {
          language: "MARTIAL ARTS",
          bar: 90
        },
        {
          language: "READING",
          bar: 95
        },
        {
          language: "SPANISH",
          bar: 50
        },
        {
          language: "PORTUGUESE",
          bar: 30
        }
      ]
    },

  // services section
  services: {
    title: "SERVICES",
    col: "col-md-12",
    icon: "fa fa-magic",
    details: [
      {
        font: "fa fa-rocket",
        mainTitle: "IDEAS",
        color: "color1",
        description:
          "The creative process is one of the most enjoyable parts of my work, and coming up with great ideas to solve them is the rocket fuel that drives me through even the most challenging projects (often well past bedtime!)"
      },
      {
        font: "fa fa-code",
        mainTitle: "WEB DEVELOPMENT",
        color: "color2",
        description:
          "I believe a good web experience is one that is structured thoughtfully, well documented, easily extensible, and doesn't make your next developer want to kick themselves in the face!  It should respond like water, and be as attractive as it is useful.  Design matters on both sides.  Period"
      },
      {
        font: "fa fa-mobile-alt fa2x",
        mainTitle: "APP DEVELOPMENT",
        color: "color3",
        description:
          "For me, app dev is about a great idea, solid code, high quality design and well thought out UX. It is a symbiotic relationship, and I love bringing a vision into a reality that fits in the palm of your hand"
      }
    ]
  },

  // Process section
  // process: {
  //   title: "WORK PROCESS",
  //   col: "col-md-12",
  //   icon: "icon-layers-alt",
  //   details: [
  //     {
  //       font: "icon-lamp",
  //       mainTitle: "IDEA"
  //     },
  //     {
  //       font: "fa fa-puzzle-piece",
  //       mainTitle: "CONCEPT"
  //     },
  //     {
  //       font: "icon-brush",
  //       mainTitle: "DESIGN"
  //     },
  //     {
  //       font: "fa fa-cube",
  //       mainTitle: "DEVELOP"
  //     },
  //     {
  //       font: "fa fa-bug",
  //       mainTitle: "TEST"
  //     },
  //     {
  //       font: "fa fa-rocket",
  //       mainTitle: "LAUNCH"
  //     }
  //   ]
  // },

  // fact section
  // fact: {
  //   title: "FUN FACT",
  //   col: "col-md-12",
  //   details: [
  //     {
  //       font: "icon-instagram-1",
  //       mainTitle: "24000 SHOTS CAPTURED"
  //     },
  //     {
  //       font: "icon-jabber",
  //       mainTitle: "37 PROJECTS COMPLETED"
  //     },
  //     {
  //       font: "icon-child",
  //       mainTitle: "87 SATISFIED CUSTOMERS"
  //     },
  //     {
  //       font: "icon-bicycle",
  //       mainTitle: "1450 KM CYCLED"
  //     }
  //   ]
  // },

  // client section
  client: {
    title: "CLIENTS",
    col: "col-md-12",
    details: [
      {
        image: image1,
        link: "https://www.playstation.com"
      },
      {
        image: image2,
        link: "https://meshh.com"
      },
      {
        image: image3,
        link: "https://ivoryworldwide.com"
      },
      {
        image: image4,
        link: "https://www.londonspeakerhire.com"
      },
      {
        image: image5,
        link: "http://chineseperformingarts.co.uk"
      },
      {
        image: image6,
        link: "http://gt-cap.com"
      }
    ]
  }
};
